import { useEffect, useState } from "react";
import * as Scrivito from "scrivito";

function Collapse({ isActive, children, className = "", onEntered, onExited }) {
  useEffect(() => {
    if (isActive) {
      onEntered?.();
    } else {
      onExited?.();
    }
  }, [isActive, onEntered, onExited]);

  return (
    <div
      className={className}
      style={isActive ? undefined : { display: "none" }}
    >
      {children}
    </div>
  );
}

function Panel({ widget, isActive, toggle }) {
  const [_entered, setEntered] = useState(false);

  return (
    <div className="collapse-widget-panel">
      <button
        type="button"
        className={`collapse-widget-panel__toggle ${
          isActive ? "--active" : "--inactive"
        }`}
        onClick={() => toggle(widget.id())}
      >
        {widget.get("headline")}
        <i className="fas fa-angle-down" />
      </button>

      <Collapse
        isActive={isActive}
        className="collapse-widget-panel__content"
        onEntered={() => setEntered(true)}
        onExited={() => setEntered(false)}
      >
        <Scrivito.ContentTag content={widget} attribute="content" />
      </Collapse>
    </div>
  );
}

export default Scrivito.connect(Panel);
